import type { LaneId } from "@fate-kingdom/engine";

export function hitTestAlphaLane(
  laneElements: ReadonlyMap<LaneId, HTMLButtonElement>,
  clientX: number,
  clientY: number,
): LaneId | null {
  for (const [laneId, element] of laneElements) {
    const rect = element.getBoundingClientRect();
    if (
      clientX >= rect.left &&
      clientX <= rect.right &&
      clientY >= rect.top &&
      clientY <= rect.bottom
    ) {
      return laneId;
    }
  }
  return null;
}
